import { render, staticRenderFns } from "./PeriodDetail.vue?vue&type=template&id=2b2ae6a0"
import script from "./PeriodDetail.vue?vue&type=script&lang=js"
export * from "./PeriodDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports